import classNames from "classnames"
import React from "react"

import { Title2 } from "@bounce/design-system"

import type { PostCardProps } from "../PostCard/PostCard"
import { PostCard } from "../PostCard/PostCard"

export type PostListProps = {
  items: PostCardProps[]
  headerRight?: React.ReactNode
  headerLeft?: React.ReactNode
  footer?: React.ReactNode
  className?: string
  title?: string
}

export const PostList = ({ title, headerRight, headerLeft, footer, items, className }: PostListProps) => {
  let gridClassName = "grid gap-6 md:gap-8 mt-14 md:mt-16"
  if (items.length <= 2) {
    gridClassName = classNames(gridClassName, "grid-cols-1 sm:grid-cols-2")
  } else {
    gridClassName = classNames(gridClassName, "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3")
  }

  return (
    <section className={classNames(className, "w-full max-w-screen-xl px-6")}>
      <header className="flex flex-row items-center justify-between">
        {headerLeft ?? <Title2 className="mr-6 text-left text-black">{title}</Title2>}
        {headerRight}
      </header>
      <div className={gridClassName}>
        {items.map((post, i) => (
          <PostCard key={i} size={items.length >= 2 ? "xs" : "sm"} {...post} />
        ))}
      </div>
      {!!footer && <footer className="mt-7 flex flex-row items-center md:mt-12">{footer}</footer>}
    </section>
  )
}
